document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".image-banner");
  console.log("[image-banner] DOMContentLoaded, blocks found:", blocks.length);
  blocks.forEach((block) => {
    initializeImageBannerFrame(block);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".image-banner")) {
    initializeImageBannerFrame(block);
  }

  block.querySelectorAll(".image-banner").forEach((imageBannerBlock) => {
    initializeImageBannerFrame(imageBannerBlock);
  });
});

function initializeImageBannerFrame(blockElement) {
  const frameElement = blockElement.querySelector(".image-banner__frame");
  const animatedPath = blockElement.querySelector(
    ".image-accordion__frame-animated-path",
  );

  console.log("[image-banner] initializeImageBannerFrame", {
    frameElement,
    animatedPath,
    alreadyInitialized: blockElement.dataset.imageBannerFrameInitialized,
  });

  if (
    !frameElement ||
    !animatedPath ||
    blockElement.dataset.imageBannerFrameInitialized === "true"
  ) {
    console.log("[image-banner] bailing — missing element or already initialized", { frameElement, animatedPath });
    return;
  }

  blockElement.dataset.imageBannerFrameInitialized = "true";

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  console.log("[image-banner] prefersReducedMotion:", prefersReducedMotion);
  let observer = null;
  let revealTimeout = null;

  if (prefersReducedMotion) {
    blockElement.classList.add("image-banner--frame-complete");
    return;
  }

  animatedPath.addEventListener("animationend", function (event) {
    console.log("[image-banner] animationend:", event.animationName);
    if (event.animationName !== "imageTextFrameDraw") {
      return;
    }

    blockElement.classList.remove("image-banner--frame-animating");
    blockElement.classList.add("image-banner--frame-complete");
  });

  const revealFrame = () => {
    console.log("[image-banner] revealFrame called");
    if (
      blockElement.classList.contains("image-banner--frame-animating") ||
      blockElement.classList.contains("image-banner--frame-complete")
    ) {
      return;
    }

    blockElement.classList.add("image-banner--frame-animating");
  };

  if (!("IntersectionObserver" in window)) {
    revealFrame();
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        console.log("[image-banner] IntersectionObserver entry:", entry.isIntersecting);
        if (
          blockElement.classList.contains("image-banner--frame-animating") ||
          blockElement.classList.contains("image-banner--frame-complete")
        ) {
          if (observer) {
            observer.disconnect();
          }
          return;
        }

        if (entry.isIntersecting) {
          if (revealTimeout) {
            return;
          }

          revealTimeout = window.setTimeout(() => {
            revealFrame();

            if (observer) {
              observer.disconnect();
            }

            revealTimeout = null;
          }, 1000);

          return;
        }

        if (revealTimeout) {
          window.clearTimeout(revealTimeout);
          revealTimeout = null;
        }
      });
    },
    {
      threshold: 0.35,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(frameElement);
}
